import { Block } from "../Block";
import { Niche } from "../niche/Niche";
import * as Templok from "@ravalmatic/templok-engine";

export class TurnDemoContainer extends Phaser.GameObjects.Container {

    private wheel: Phaser.GameObjects.Image;
    private glow: Phaser.GameObjects.Image;
    private rotatedBlockData: Templok.BlockData;
    private rotationContainer: Phaser.GameObjects.Container;
    private block: Block;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const title = new Phaser.GameObjects.Text(this.scene, 25, -140, "TURN FEATURE", {fontFamily: "Futura-Medium", fontSize: "22px", color: "#FFFFFF", align: "center"});
        title.setOrigin(.5);
        this.add(title);

        const turnButton = new Phaser.GameObjects.Image(this.scene, -90, -140, "texture_atlas_2", "btn_spin_on_off");
        turnButton.setScale(.8);
        this.add(turnButton);

        const wheelContainer = new Phaser.GameObjects.Container(this.scene);
        wheelContainer.setScale(.85);
        this.add(wheelContainer);

        this.wheel = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "stone_wheel");
        wheelContainer.add(this.wheel);

        this.glow = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "stone_wheel_glow");
        this.glow.alpha = 0;
        wheelContainer.add(this.glow);

        const border = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "stone_wheel_light");
        wheelContainer.add(border);

        this.rotationContainer = new Phaser.GameObjects.Container(this.scene);
        this.rotationContainer.setScale(.85);
        this.add(this.rotationContainer);

        this.rotatedBlockData = {
            id: -1,
            n: 5,
            data: [34956, 7936, 50244, 63488],
            i: 0
        };

        this.block = new Block(this.scene, null, this.rotatedBlockData, 1, 0, 0, true);
        this.rotationContainer.add(this.block);

        this.scene.time.delayedCall(500, function(): void {
            this.rotate();
        }, [], this);  
    }

    private rotate (): void {

        if (typeof this.scene === "undefined") {
            return;
        }

        const a = this.wheel.angle;

        this.scene.tweens.add({
            targets: [this.wheel, this.glow],
            angle: a + 90,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: Niche.ROTATION_TIME
        });

        this.scene.tweens.add({
            targets: this.rotationContainer,
            angle: 90,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: Niche.ROTATION_TIME,
            onComplete: this.onRotationComplete,
            onCompleteScope: this
        });

        this.block.onRotation();

        this.glow.alpha = 0;

        this.scene.tweens.add({
            targets: this.glow,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: Niche.ROTATION_TIME / 2
        });
    }

    private onRotationComplete(): void {

        if (typeof this.scene === "undefined") {
            return;
        }

        this.rotatedBlockData.i = this.rotatedBlockData.i < 3 ? this.rotatedBlockData.i + 1 : 0;

        this.rotationContainer.angle = 0;

        this.block.destroy();

        this.block = new Block(this.scene, null, this.rotatedBlockData, 1, 0, 0, true);
        this.rotationContainer.add(this.block);

        this.scene.tweens.add({
            targets: this.glow,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: Niche.ROTATION_TIME / 2,
            delay: Niche.ROTATION_TIME / 2
        });

        this.scene.time.delayedCall(2000, function(): void {
            this.rotate();
        }, [], this);  
    }
}
